import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
});

// Response interceptor - unwrap errors nicely
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const message = err.response?.data?.error || err.message || 'Ошибка сети';
    return Promise.reject(new Error(message));
  }
);

export default api;
